import {useState, useEffect} from "react";
import './App.css';

import RoutePath from "./routes/RoutePath";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from "./contexts/provider/AuthProvider";
import {SearchProvider} from "./components/ui/search/search.context.tsx"
import { SiteSettingProvider } from "./contexts/site-settings/site-settings";
//import {SpeclizationFilterProvider} from "./contexts/speclization-filter/speclization-filter.context.tsx";
import ScrollToTop from "react-scroll-to-top";
import { HelmetProvider } from 'react-helmet-async';
import { BiUpArrow } from "react-icons/bi";

// "homepage": "https://www.healthlogist.com/",

function App() {
	const [theme, setTheme] = useState('light')
	useEffect(() => {
		//console.log('rand num=====', rand_num)
		const theme = localStorage.getItem('theme')
		if(theme){
			setTheme(theme)
		}
	})
	const queryClient = new QueryClient();

	return (
		<div dir="ltr" class={theme}>
			<HelmetProvider>
			<QueryClientProvider client={queryClient}>
			<div className="flex flex-col min-h-screen transition-colors duration-150 bg-gray-100">
			<SiteSettingProvider>
			<SearchProvider>
			<AuthProvider>
				<RoutePath />
			</AuthProvider>
			</SearchProvider>
			</SiteSettingProvider>
			</div>
			<ToastContainer theme="colored" />    
			<ScrollToTop smooth component={<BiUpArrow color='white' />} className="flex items-center justify-center" style={{backgroundColor:'#18cb96',bottom: '60px',
right: '15px'}} />
		</QueryClientProvider>
		</HelmetProvider>
		</div>
	);
}

export default App;
